/**
 * The mobile bar. Five destinations, not a scaled-down sidebar.
 *
 * Targets are 44 pixels because that is the size a thumb actually hits, and a
 * mis-hit here is a mis-hit on a screen about money.
 */
import { MoreHorizontal } from "lucide-react";
import { NavLink } from "react-router";

import { SECTIONS, sectionsFor } from "./navigation";

const PRIMARY = SECTIONS.filter((section) => section.onMobile);

export function MobileNav({ platform = false, client = false }: { readonly platform?: boolean; readonly client?: boolean }): React.JSX.Element {
  return (
    <nav
      // Named differently from the sidebar. Two navigations with the same
      // name are ambiguous to anything reading the page aloud, and only one of
      // them is on screen at a time anyway.
      aria-label="Основные разделы"
      className="fixed inset-x-0 bottom-0 flex border-t border-border-subtle bg-surface-default shell:hidden"
    >
      {(client ? sectionsFor([], false, true) : platform ? sectionsFor([], true) : PRIMARY).map((section) => (
        <NavLink
          key={section.path}
          to={section.path}
          end={section.path === "/app"}
          className={({ isActive }) =>
            [
              // `min-w-0` so a long label truncates instead of widening the
              // bar: a flex item will not shrink below its content otherwise,
              // and "Позиции и ордера" pushed the page seven pixels wide.
              "flex min-h-11 min-w-0 flex-1 cursor-pointer flex-col items-center justify-center gap-1 py-2 text-xs",
              "focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-focus-ring",
              isActive ? "text-text-primary" : "text-text-secondary",
            ].join(" ")
          }
        >
          <section.icon aria-hidden="true" className="size-5" />
          <span className="w-full truncate px-1 text-center">{section.short ?? section.label}</span>
        </NavLink>
      ))}
      {!client && <NavLink
        to="/app/more"
        className="flex min-h-11 min-w-0 flex-1 cursor-pointer flex-col items-center justify-center gap-1 py-2 text-xs text-text-secondary focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-focus-ring"
      >
        <MoreHorizontal aria-hidden="true" className="size-5" />
        <span>Ещё</span>
      </NavLink>}
    </nav>
  );
}
